<template>
    <div id="app">
        <Nav class="nav"></Nav>
        <Header class="header" :scrolled="scrolled"></Header>
        <div class="mainContent">
            <Page1 :scrolled="scrolled"></Page1>
            <Page2 ></Page2>
            <Page3 @visualizouPage3="visualizouPage3"></Page3>
            <Page4 v-if="page3Vista"> </Page4>
            <Page5 v-if="page3Vista"> </Page5>
            <Page6 v-if="page3Vista"> </Page6>
            <Page7 v-if="page3Vista"> </Page7>
            <Page8 v-if="page3Vista"> </Page8>
            <Page9 v-if="page3Vista"> </Page9>
            <Page10 v-if="page3Vista"></Page10>
            <Page11 v-if="page3Vista"></Page11>
            <Page12 v-if="page3Vista"></Page12>
            <Page13 v-if="page3Vista"></Page13>
            <Page14 v-if="page3Vista"></Page14>
            <Page15 v-if="page3Vista"></Page15>
            <Page16 v-if="page3Vista"></Page16>
            <Page17 v-if="page3Vista"></Page17>
        </div>
        <Footer v-if="page3Vista"></Footer>
        <Gotopo></Gotopo>
    </div>
</template>

<script>
import AOS from "aos";
import Nav from "./components/Nav";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Gotopo from "./components/Gotopo";
import Page1 from "./views/Page1";
import Page2 from "./views/Page2";
import Page3 from "./views/Page3";
import Page4 from "./views/Page4";
import Page5 from "./views/Page5";
import Page6 from "./views/Page6";
import Page7 from "./views/Page7";
import Page8 from "./views/Page8";
import Page9 from "./views/Page9";
import Page10 from "./views/Page10";
import Page11 from "./views/Page11";
import Page12 from "./views/Page12";
import Page13 from "./views/Page13";
import Page14 from "./views/Page14";
import Page15 from "./views/Page15";
import Page16 from "./views/Page16";
import Page17 from "./views/Page17";

export default {
    name: "App",
    data() {
        return {
            scrolled: false,
            localizacao: 0,
            page3Vista: false,
        };
    },
    methods: {
        visualizouPage3() {
            this.page3Vista = true;
        },
        scroll() {
            window.onscroll = () => {
                var soma =
                    document.documentElement.scrollTop + window.innerHeight;
                this.localizacao = soma;
            };
        },
        getDocHeight() {
            var D = document;
            return Math.max(
                D.body.scrollHeight,
                D.documentElement.scrollHeight,
                D.body.offsetHeight,
                D.documentElement.offsetHeight,
                D.body.clientHeight,
                D.documentElement.clientHeight
            );
        },
        setScroll() {
            // console.log("voltou!", this.localizacao);
            window.scrollTo(0, Number(this.localizacao));
            this.scroll();
        },

        handleScroll() {
            if (window.scrollY) {
                this.scrolled = true;
                // console.log("scrolled");
            } else {
                this.scrolled = false;
            }
            if (
                navigator.userAgent.indexOf("MSIE") !== -1 ||
                navigator.appVersion.indexOf("Trident/") > -1
            ) {
                /* Microsoft Internet Explorer detected in. */
                if (window.pageYOffset > 0) {
                    document.querySelector(".nav").classList.add("bgactive");
                } else {
                    document.querySelector(".nav").classList.remove("bgactive");
                }
            }
        },
    },
    created() {
        AOS.init({
            once: true,
            easing: "ease-out-quad",
        });
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    mounted() {
        this.scroll();
        setTimeout(() => {
            this.setScroll();
        }, 100);
    },
    components: {
        Nav,
        Header,
        Footer,
        Gotopo,
        Page1,
        Page2,
        Page3,
        Page4,
        Page5,
        Page6,
        Page7,
        Page8,
        Page9,
        Page10,
        Page11,
        Page12,
        Page13,
        Page14,
        Page15,
        Page16,
        Page17,
    },
};
</script>

<style lang="scss">
header {
    background-image: url("~@/assets/img/header-background.png");
    background-attachment: fixed;
    background-size: cover;
    width: 100%;
    height: 100vh;
}
.contraste {
    filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
    filter: gray;
    -webkit-filter: grayscale(100%);
    -webkit-transition: all 0.6s ease;
    -webkit-backface-visibility: hidden;
}
body {
    overflow-x: hidden;
    font-size: 17px;
    #app {
        font-family: "Roboto";
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: $color-french-grey;
        height: 100vh;

        .mainContent {
            max-width: 1920px;
            position: relative;
            background-color: white;
            margin: 0 auto;
            // border-radius: 20px 20px 0px 0px;
            box-shadow: 20px 0px 99px 0px rgba(0, 0, 0, 0.3);
            z-index: 3;
        }
        .nav {
            z-index: 4;
        }
        .header {
            z-index: 1;
        }
        .footer {
            z-index: 2;
        }
    }
}
// @media (max-width: 580px){
//     .nav{
//         display: none;
//     }
// }
</style>
